// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../font/app.eot?2633928", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../font/app.woff?2633928", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../font/app.ttf?2633928", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../font/app.svg?2633928", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#bpmnio" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

html, body {

  font-family: "IBM Plex Sans",sans-serif;

  font-size: 12px;
  color: #444;

  height: 100%;
  padding: 0;
  margin: 0;
}

h1, h2, h3, h4 {
  font-weight: normal;
}

.content {
  width: 100%;
  height: 100%;

  overflow: hidden;
}


/** widgets **/

.io-control {
  background: #FFF;
  border: #EEE;
  border-radius: 2px;
  padding: 5px;
}

.bjs-powered-by {
  padding-bottom: 2px;
}

.io-control-list {
  list-style: none;

  padding: 5px;
  margin: 0;
}

button.inactive,
a.inactive {
  color: #E0E0E0;
  color: rgba(10, 10, 10, 0.4) !important;
  cursor: default;
}

.close {
  font-size: 21px;
  font-weight: 700;
  text-shadow: 0 1px 0 #FFF;
  opacity: .2;
  line-height: 1;
  vertical-align: middle;
  margin-left: 5px;
}

a:link {
  text-decoration: none;
}

button,
a,
a:visited {
  color: #555;
}

button:hover,
a:hover {
  color: #333;
}

.vr {
  display: inline-block;
  height: 26px;
  border-right: solid 1px #999;
  vertical-align: top;
}

.io-control-list a,
.io-control-list button {
  padding: 0;
  outline: none;

  cursor: pointer;
  font-size: 22px;
  line-height: 26px;

  background: none;
  border: none;
}

.io-control-list.io-horizontal,
.io-control-list.io-horizontal li {
  display: inline-block;
}

.io-control-list.io-horizontal a,
.io-control-list.io-horizontal button {
  padding: 2px;
  margin: 0 5px;
}

.io-control hr {
  border: none;
  border-top: solid 1px #EEE;
}


/** dialogs */

.io-dialog {
  display: none;
}

.io-dialog.open {
  display: block;
}

.io-dialog.open:before {
  content: '';
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;

  background: #666;
  opacity: 0.2;

  z-index: 1001;
}

.io-dialog .content {
  position: fixed;

  background: white;
  padding: 10px 30px 20px 30px;

  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  border-radius: 2px;

  height: auto;

  z-index: 1001;
}

.io-dialog .project-logo {
  position: absolute;
  bottom: 27px;
  right: 27px;
  width: 54px;
  height: 54px;
  font-size: 48px;
}

@media (max-width: 599px) {
  .io-dialog .content {
    left: 20px;
    right: 20px;
    top: 20px;
    width: auto;
  }
}

@media (min-width: 600px) {

  .io-dialog .content {
    width: 600px;
    left: 50%;
    margin-left: -300px;
    top: 100px;
  }
}

/** fonts **/

@font-face {
  font-family: 'bpmnio';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
}

[class^="icon-"]:before,
[class*=" icon-"]:before {
  font-family: "bpmnio";
  font-style: normal;
  font-weight: normal;
  speak: none;

  display: inline-block;
  text-decoration: inherit;
  width: 1em;
  text-align: center;

  font-variant: normal;
  text-transform: none;

  line-height: 1em;
}

.icon-plus:before { content: '\\e800'; }
.icon-loading:before { content: '\\e801'; }
.icon-minus:before { content: '\\e802'; }
.icon-open:before { content: '\\e803'; }
.icon-picture:before { content: '\\e804'; }
.icon-download:before { content: '\\e805'; }
.icon-size-reset:before { content: '\\e806'; }
.icon-bpmn-io:before { content: '\\e807'; }
.icon-info:before { content: '\\e808'; }
.icon-comment:before { content: '\\e809'; }
.icon-undo:before { content: '\\e80a'; }
.icon-redo:before { content: '\\e80b'; }
.icon-plus-circled:before { content: '\\e80c'; }`, "",{"version":3,"sources":["webpack://./client/diff/css/base.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,uCAAuC;;EAEvC,eAAe;EACf,WAAW;;EAEX,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,gBAAgB;AAClB;;;AAGA,cAAc;;AAEd;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;;EAEhB,YAAY;EACZ,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,aAAa;;EAEb,eAAe;EACf,eAAe;EACf,iBAAiB;;EAEjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;;AAGA,aAAa;;AAEb;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,OAAO;EACP,MAAM;EACN,SAAS;EACT,QAAQ;;EAER,gBAAgB;EAChB,YAAY;;EAEZ,aAAa;AACf;;AAEA;EACE,eAAe;;EAEf,iBAAiB;EACjB,4BAA4B;;EAE5B,wCAAwC;EACxC,kBAAkB;;EAElB,YAAY;;EAEZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,SAAS;IACT,WAAW;EACb;AACF;;AAEA;;EAEE;IACE,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,YAAY;;AAEZ;EACE,qBAAqB;EACrB,4CAAsC;EACtC;;;4DAG2D;EAC3D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;;EAEX,qBAAqB;EACrB,wBAAwB;EACxB,UAAU;EACV,kBAAkB;;EAElB,oBAAoB;EACpB,oBAAoB;;EAEpB,gBAAgB;AAClB;;AAEA,oBAAoB,gBAAgB,EAAE;AACtC,uBAAuB,gBAAgB,EAAE;AACzC,qBAAqB,gBAAgB,EAAE;AACvC,oBAAoB,gBAAgB,EAAE;AACtC,uBAAuB,gBAAgB,EAAE;AACzC,wBAAwB,gBAAgB,EAAE;AAC1C,0BAA0B,gBAAgB,EAAE;AAC5C,uBAAuB,gBAAgB,EAAE;AACzC,oBAAoB,gBAAgB,EAAE;AACtC,uBAAuB,gBAAgB,EAAE;AACzC,oBAAoB,gBAAgB,EAAE;AACtC,oBAAoB,gBAAgB,EAAE;AACtC,4BAA4B,gBAAgB,EAAE","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nhtml, body {\n\n  font-family: \"IBM Plex Sans\",sans-serif;\n\n  font-size: 12px;\n  color: #444;\n\n  height: 100%;\n  padding: 0;\n  margin: 0;\n}\n\nh1, h2, h3, h4 {\n  font-weight: normal;\n}\n\n.content {\n  width: 100%;\n  height: 100%;\n\n  overflow: hidden;\n}\n\n\n/** widgets **/\n\n.io-control {\n  background: #FFF;\n  border: #EEE;\n  border-radius: 2px;\n  padding: 5px;\n}\n\n.bjs-powered-by {\n  padding-bottom: 2px;\n}\n\n.io-control-list {\n  list-style: none;\n\n  padding: 5px;\n  margin: 0;\n}\n\nbutton.inactive,\na.inactive {\n  color: #E0E0E0;\n  color: rgba(10, 10, 10, 0.4) !important;\n  cursor: default;\n}\n\n.close {\n  font-size: 21px;\n  font-weight: 700;\n  text-shadow: 0 1px 0 #FFF;\n  opacity: .2;\n  line-height: 1;\n  vertical-align: middle;\n  margin-left: 5px;\n}\n\na:link {\n  text-decoration: none;\n}\n\nbutton,\na,\na:visited {\n  color: #555;\n}\n\nbutton:hover,\na:hover {\n  color: #333;\n}\n\n.vr {\n  display: inline-block;\n  height: 26px;\n  border-right: solid 1px #999;\n  vertical-align: top;\n}\n\n.io-control-list a,\n.io-control-list button {\n  padding: 0;\n  outline: none;\n\n  cursor: pointer;\n  font-size: 22px;\n  line-height: 26px;\n\n  background: none;\n  border: none;\n}\n\n.io-control-list.io-horizontal,\n.io-control-list.io-horizontal li {\n  display: inline-block;\n}\n\n.io-control-list.io-horizontal a,\n.io-control-list.io-horizontal button {\n  padding: 2px;\n  margin: 0 5px;\n}\n\n.io-control hr {\n  border: none;\n  border-top: solid 1px #EEE;\n}\n\n\n/** dialogs */\n\n.io-dialog {\n  display: none;\n}\n\n.io-dialog.open {\n  display: block;\n}\n\n.io-dialog.open:before {\n  content: '';\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n\n  background: #666;\n  opacity: 0.2;\n\n  z-index: 1001;\n}\n\n.io-dialog .content {\n  position: fixed;\n\n  background: white;\n  padding: 10px 30px 20px 30px;\n\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);\n  border-radius: 2px;\n\n  height: auto;\n\n  z-index: 1001;\n}\n\n.io-dialog .project-logo {\n  position: absolute;\n  bottom: 27px;\n  right: 27px;\n  width: 54px;\n  height: 54px;\n  font-size: 48px;\n}\n\n@media (max-width: 599px) {\n  .io-dialog .content {\n    left: 20px;\n    right: 20px;\n    top: 20px;\n    width: auto;\n  }\n}\n\n@media (min-width: 600px) {\n\n  .io-dialog .content {\n    width: 600px;\n    left: 50%;\n    margin-left: -300px;\n    top: 100px;\n  }\n}\n\n/** fonts **/\n\n@font-face {\n  font-family: 'bpmnio';\n  src: url('../../font/app.eot?2633928');\n  src: url('../../font/app.eot?2633928#iefix') format('embedded-opentype'),\n       url('../../font/app.woff?2633928') format('woff'),\n       url('../../font/app.ttf?2633928') format('truetype'),\n       url('../../font/app.svg?2633928#bpmnio') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n[class^=\"icon-\"]:before,\n[class*=\" icon-\"]:before {\n  font-family: \"bpmnio\";\n  font-style: normal;\n  font-weight: normal;\n  speak: none;\n\n  display: inline-block;\n  text-decoration: inherit;\n  width: 1em;\n  text-align: center;\n\n  font-variant: normal;\n  text-transform: none;\n\n  line-height: 1em;\n}\n\n.icon-plus:before { content: '\\e800'; }\n.icon-loading:before { content: '\\e801'; }\n.icon-minus:before { content: '\\e802'; }\n.icon-open:before { content: '\\e803'; }\n.icon-picture:before { content: '\\e804'; }\n.icon-download:before { content: '\\e805'; }\n.icon-size-reset:before { content: '\\e806'; }\n.icon-bpmn-io:before { content: '\\e807'; }\n.icon-info:before { content: '\\e808'; }\n.icon-comment:before { content: '\\e809'; }\n.icon-undo:before { content: '\\e80a'; }\n.icon-redo:before { content: '\\e80b'; }\n.icon-plus-circled:before { content: '\\e80c'; }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
